import { Paper, Table, TableContainer, TableHead, TableCell, TableBody, TableRow, Typography } from "@mui/material";

export default function Free({data}){

    const find = (p,c) => {
        const item = data.find(i => i.process === p && i.category === c);
        return parseFloat((item && item.enrollments) || 0).toLocaleString();
    }

    return <>

        <Typography variant='h3'>Inscriptions par type de prise en charge</Typography>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Dentaire</TableCell>
                        <TableCell>Kiné</TableCell>
                        <TableCell>Médecine</TableCell>
                        <TableCell>Pharma</TableCell>
                        <TableCell>Santé Mentale</TableCell>
                        <TableCell>Infirmier</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>DPC Formation Continue</TableCell>
                        <TableCell>{find('dpc','dentaire')}</TableCell>
                        <TableCell>{find('dpc','kine')}</TableCell>
                        <TableCell>{find('dpc','medecine')}</TableCell>
                        <TableCell>{find('dpc','pharma')}</TableCell>
                        <TableCell>{find('dpc','sante-mentale')}</TableCell>
                        <TableCell>{find('dpc','infirmiere')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>DPC Programme Intégré</TableCell>
                        <TableCell>{find('dpc-pi','dentaire')}</TableCell>
                        <TableCell>{find('dpc-pi','kine')}</TableCell>
                        <TableCell>{find('dpc-pi','medecine')}</TableCell>
                        <TableCell>{find('dpc-pi','pharma')}</TableCell>
                        <TableCell>{find('dpc-pi','sante-mentale')}</TableCell>
                        <TableCell>{find('dpc-pi','infirmiere')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>FIFPL</TableCell>
                        <TableCell>{find('fifpl','dentaire')}</TableCell>
                        <TableCell>{find('fifpl','kine')}</TableCell>
                        <TableCell>{find('fifpl','medecine')}</TableCell>
                        <TableCell>{find('fifpl','pharma')}</TableCell>
                        <TableCell>{find('fifpl','sante-mentale')}</TableCell>
                        <TableCell>{find('fifpl','infirmiere')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>FAFPM</TableCell>
                        <TableCell>{find('fafpm','dentaire')}</TableCell>
                        <TableCell>{find('fafpm','kine')}</TableCell>
                        <TableCell>{find('fafpm','medecine')}</TableCell>
                        <TableCell>{find('fafpm','pharma')}</TableCell>
                        <TableCell>{find('fafpm','sante-mentale')}</TableCell>
                        <TableCell>{find('fafpm','infirmiere')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>OPCO</TableCell>
                        <TableCell>{find('opco','dentaire')}</TableCell>
                        <TableCell>{find('opco','kine')}</TableCell>
                        <TableCell>{find('opco','medecine')}</TableCell>
                        <TableCell>{find('opco','pharma')}</TableCell>
                        <TableCell>{find('opco','sante-mentale')}</TableCell>
                        <TableCell>{find('opco','infirmiere')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Achat Direct</TableCell>
                        <TableCell>{find('standard','dentaire')}</TableCell>
                        <TableCell>{find('standard','kine')}</TableCell>
                        <TableCell>{find('standard','medecine')}</TableCell>
                        <TableCell>{find('standard','pharma')}</TableCell>
                        <TableCell>{find('standard','sante-mentale')}</TableCell>
                        <TableCell>{find('standard','infirmiere')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Etudiant</TableCell>
                        <TableCell>{find('etudiant','dentaire')}</TableCell>
                        <TableCell>{find('etudiant','kine')}</TableCell>
                        <TableCell>{find('etudiant','medecine')}</TableCell>
                        <TableCell>{find('etudiant','pharma')}</TableCell>
                        <TableCell>{find('etudiant','sante-mentale')}</TableCell>
                        <TableCell>{find('etudiant','infirmiere')}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Récompense</TableCell>
                        <TableCell>{find('recompense','dentaire')}</TableCell>
                        <TableCell>{find('recompense','kine')}</TableCell>
                        <TableCell>{find('recompense','medecine')}</TableCell>
                        <TableCell>{find('recompense','pharma')}</TableCell>
                        <TableCell>{find('recompense','sante-mentale')}</TableCell>
                        <TableCell>{find('recompense','infirmiere')}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    </>

}